import { Tooltip as BoostrapTooltip } from 'bootstrap';

export default class Tooltip extends BoostrapTooltip {
    static initAll(selector) {
        new Tooltip(document.querySelector('body'), {
            selector: selector,
        });
    }
}
